import { Pipe, PipeTransform } from '@angular/core';
import {UserModel} from "../models/user.model";

@Pipe({
  name: 'chatReplaceUserEmail',
  standalone: true,
  pure: true
})
export class ChatReplaceUserEmail implements PipeTransform {
  // to replace '{{user.email}}' with registered user email in a chat message

  transform(message: string, user: UserModel | null ): string {
    if (!message || !user) return message;

    // const regex = /\{\{user\.email\}\}/g;
    return message.replace('{{user.email}}', user.email)
  }
}
